<template>
  <el-row>
    <el-col>
      <span class="cs-title">消费记录</span>
      <span class="cs-blue cs-accountList-viewDetail" @click="viewDetails">
        <span>查看明细</span>
        <i class="fa fa-chevron-down" v-if="!isShowDetails" aria-hidden="true"></i>
        <i class="fa fa-chevron-up" v-if="isShowDetails" aria-hidden="true"></i>
      </span>
      <el-row class="hidden-xs-only">
        <el-col :span="18">
          <label> &nbsp; </label>
        </el-col>
      </el-row>
      <el-row v-if="isShowDetails" class="grid-content">
        <el-col :span="22" :xs="24">
          <el-table ref="paymentHistory" :data="paymentHistory" :header-row-class-name="'el-table-header'" :cell-class-name="cellStyle" :show-summary="true"
            :summary-method="getTabelSummaries">
            <el-table-column prop="PaymentName" label="名称" class-name="courses-history-colmun-width" />
            <el-table-column prop="CreateDateString" label="日期" class-name="courses-history-colmun-width" />
            <el-table-column prop="Amount" label="金额" class-name="courses-history-colmun-width">
              <template #default="{row}">
                {{row.Amount | toCurrency(row.Currency)}}
              </template>
            </el-table-column>
            <el-table-column prop="PaymentTypeDesc" label="付款方式" class-name="courses-history-colmun-width" />
            <!-- <el-table-column prop="Bill" label="查看收据" fixed="right" :min-width="80">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="onCheckBill(scope.row)">
                                查看收据
                            </el-button>
                        </template>
                    </el-table-column> -->
          </el-table>
        </el-col>
      </el-row>
    </el-col>
    <el-dialog title="查看收据" :close-on-click-modal="false" :visible.sync="pdfPreviewerVisible" top="8vh" width="80%">
      <pdfPreviewer :fileData="fileData"></pdfPreviewer>
    </el-dialog>
  </el-row>
</template>

<style lang="scss" scoped>
.el-table {
  /deep/ .el-table__footer td {
    background-color: #c9c9c9;
  }
}

.courses-history-colmun-width {
  min-width: 120px;
}

.course-score-selector {
  height: 30px;
  line-height: 30px;
  width: 100px;
}
</style>

<script>
import {
  getStudentPaymentHistory,
  getStudentPaymentReceipt,
} from "../../service/student.service";
import { getFile } from "../../service/common.service";
import { getScoreList } from "../../config/mUtils.js";
import pdfPreviewer from "../PDFPreviewer.vue";

const mixin_generalMethods = {
  methods: {
    getTabelSummaries({ columns, data }) {
      let sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总支付";
          return;
        }

        if ([1, 3].contains(index)) {
          sums[index] = String.empty;
          return;
        }

        let sumValue = data.sum((row) => row[column.property]);
        sums[index] = Object.toCurrency(sumValue, this.currency);
      });

      return sums;
    },
  },
};

export default {
  mixins: [mixin_generalMethods],
  components: {
    pdfPreviewer,
  },
  props: ["studentId"],
  data() {
    return {
      isShowDetails: false,
      fileData: "",
      pdfPreviewerVisible: false,
      paymentHistory: [],
    };
  },
  computed: {
    currency() {
      if (this.paymentHistory.length === 0) {
        return this.GLOBAL.currencyType.CAD;
      }

      return this.paymentHistory[0].Currency;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    viewDetails() {
      this.isShowDetails = !this.isShowDetails;
    },
    initData() {
      getStudentPaymentHistory(this.studentId).then((result) => {
        if (!!result && result.success) {
          this.paymentHistory = result.data;
        }
      });
    },
    onCheckBill(row) {
      if (!row.RecieptFileId || row.RecieptFileId == 0) {
        this.$message.error("未获取到该收据");
      }
      getFile(row.RecieptFileId).then((result) => {
        if (result.success) {
          var url = window.URL.createObjectURL(result.data);
          this.fileData = url;
          this.pdfPreviewerVisible = true;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/studentPaymentHistory.vue